const removeUndefinedFields = (obj = {}) => {
  return Object.fromEntries(Object.entries(obj).filter((n) => !!n[1]));
};

export default removeUndefinedFields;
